import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { registerCompany, formatApiError } from "@/auth";
import { AuthShell, Field, ErrorBox, PrimaryButton } from "@/components/AuthShell";

export default function RegisterCompany({ onAuthed }) {
  const [form, setForm] = useState({ company_name: "", name: "", email: "", password: "", confirm: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) return setError("Passwords do not match.");
    setBusy(true); setError("");
    try {
      const u = await registerCompany({ company_name: form.company_name, name: form.name, email: form.email.trim(), password: form.password });
      onAuthed && onAuthed(u);
      nav("/connect-fsm", { replace: true });
    } catch (err) {
      setError(formatApiError(err, "Could not create the account."));
    } finally { setBusy(false); }
  };

  return (
    <AuthShell testId="register-screen" title="Create your company account" subtitle="You become the company owner. Start on the free trial, invite your staff, upgrade anytime.">
      <form onSubmit={submit} className="space-y-3">
        <Field label="Company name" testId="register-company" value={form.company_name} onChange={set("company_name")} placeholder="Acme Heating & Air" required autoFocus />
        <Field label="Your name" testId="register-name" value={form.name} onChange={set("name")} placeholder="Jane Owner" required />
        <Field label="Work email" testId="register-email" type="email" value={form.email} onChange={set("email")} placeholder="jane@acmehvac.com" required />
        <Field label="Password (8+ characters, letter and number)" testId="register-password" type="password" value={form.password} onChange={set("password")} required />
        <Field label="Confirm password" testId="register-confirm" type="password" value={form.confirm} onChange={set("confirm")} required />
        <ErrorBox error={error} testId="register-error" />
        <PrimaryButton testId="register-submit" type="submit" disabled={busy}>
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Create account
        </PrimaryButton>
      </form>
      <p className="mt-5 text-center text-xs text-slate-500">
        Already have an account? <Link data-testid="go-login-link" to="/login" className="text-orange-400 hover:underline">Sign in</Link>
      </p>
    </AuthShell>
  );
}
